import React from "react";
import { Link } from "react-router-dom";
import { Ship, Mail, MapPin, Anchor } from "lucide-react";
import { NAV_LINKS, CONTACT } from "../data";
import { LANDING_LINKS } from "../data/landingPages";
import { openEnquiry } from "./common";

const go = (href) => {
  const el = document.querySelector(href);
  if (el) el.scrollIntoView({ behavior: "smooth" });
  else window.location.assign("/" + href);
};

const Footer = () => (
  <footer data-testid="site-footer" className="relative overflow-hidden border-t border-white/10 bg-black pt-20">
    {/* Final CTA */}
    <div className="mx-auto max-w-7xl px-5 sm:px-8">
      <div className="rounded-3xl border border-vivid-magenta/30 bg-gradient-to-br from-vivid-surface to-black p-10 text-center shadow-[0_0_50px_rgba(255,0,122,0.15)] sm:p-16">
        <h2 className="font-heading text-4xl font-bold tracking-tight sm:text-5xl">
          Ready for the <span className="text-gradient-vivid">best Vivid cruise in Sydney?</span>
        </h2>
        <p className="mx-auto mt-4 max-w-2xl text-white/70">
          Secure your seats with Vivid Cruises Sydney and experience Vivid Sydney from the water. Adults $49, Kids $35.
          Evening sailings sell out, book early.
        </p>
        <div className="mt-8 flex flex-wrap justify-center gap-4">
          <button
            data-testid="footer-book-btn"
            onClick={() => go("#tickets")}
            className="rounded-full bg-vivid-magenta px-8 py-4 font-medium text-white shadow-[0_0_24px_rgba(255,0,122,0.4)] transition hover:bg-vivid-magentaHover hover:-translate-y-1"
          >
            <Anchor className="mr-2 inline h-5 w-5" /> Book Your Vivid Cruise
          </button>
          <button
            data-testid="footer-enquire-btn"
            onClick={() => openEnquiry("General")}
            className="rounded-full border border-white/15 bg-white/5 px-8 py-4 font-medium text-white backdrop-blur-md transition hover:bg-white/10 hover:-translate-y-1"
          >
            Send an Enquiry
          </button>
        </div>
      </div>
    </div>

    <div className="mx-auto mt-16 max-w-7xl px-5 sm:px-8">
      <div className="grid gap-10 border-t border-white/10 py-14 md:grid-cols-4">
        <div className="md:col-span-1">
          <div className="flex items-center gap-2">
            <Ship className="h-6 w-6 text-vivid-magenta" />
            <span className="font-heading text-lg font-extrabold">Vivid Cruises Sydney</span>
          </div>
          <p className="mt-4 text-sm leading-relaxed text-white/60">{CONTACT.tagline}. Premier Vivid Sydney Harbour cruises with Vivid Cruises Sydney.</p>
          <a href={`mailto:${CONTACT.email}`} data-testid="footer-email-link" className="mt-4 inline-flex items-center gap-2 text-sm text-vivid-cyan hover:text-white">
            <Mail className="h-4 w-4" /> {CONTACT.email}
          </a>
          <p className="mt-3 inline-flex flex-wrap items-center gap-2 text-sm text-white/60">
            <MapPin className="h-4 w-4" /> {CONTACT.depart}
            <a href={CONTACT.directions} target="_blank" rel="noopener noreferrer" data-testid="footer-directions-link" className="text-vivid-cyan underline-offset-2 hover:underline">Get directions</a>
          </p>
        </div>

        <nav className="md:col-span-1" aria-label="Footer navigation">
          <h3 className="text-sm font-semibold uppercase tracking-wider text-white/80">Explore</h3>
          <ul className="mt-4 space-y-2">
            {NAV_LINKS.map((l) => (
              <li key={l.href}>
                <button onClick={() => go(l.href)} className="text-sm text-white/60 transition hover:text-white">{l.label}</button>
              </li>
            ))}
          </ul>
        </nav>

        <div className="md:col-span-2">
          <h3 className="text-sm font-semibold uppercase tracking-wider text-white/80">Vivid cruise pages</h3>
          <ul className="mt-4 flex flex-wrap gap-2">
            {LANDING_LINKS.map((l) => (
              <li key={l.slug}>
                <Link to={`/${l.slug}`} className="rounded-full border border-white/10 bg-white/5 px-3 py-1.5 text-xs text-white/60 transition hover:border-vivid-magenta/40 hover:text-white">
                  {l.label}
                </Link>
              </li>
            ))}
          </ul>
          <p className="mt-6 text-xs leading-relaxed text-white/40">
            Vivid Cruises Sydney operates Vivid Sydney Harbour cruises during the Vivid Sydney festival,
            with front row views of the Sydney Opera House, Sydney Harbour Bridge, Circular Quay, Barangaroo,
            Luna Park, Milsons Point, The Rocks and Darling Harbour light installations.
          </p>
        </div>
      </div>

      <div className="flex flex-col items-center justify-between gap-4 border-t border-white/10 py-8 sm:flex-row">
        <p className="text-xs text-white/40">© {new Date().getFullYear()} Vivid Cruises Sydney · Vivid Sydney Harbour Cruise. All rights reserved.</p>
        <p className="text-xs text-white/40">King Street Wharf, Wharf 3 · Sydney Harbour · NSW, Australia</p>
      </div>
    </div>

    <div aria-hidden className="pointer-events-none select-none overflow-hidden">
      <p className="whitespace-nowrap text-center font-heading text-[13vw] font-black leading-none tracking-tighter text-white/[0.03]">VIVID SYDNEY</p>
    </div>
  </footer>
);

export default Footer;
